import { PDP_STICKY_COMPONENT_Z_INDEX } from '@/components/content/Header/constants';
import { SxProps } from '@mui/material';

export const productBarStickySX: Record<string, SxProps> = {
	container: {
		width: '100%',
		display: 'flex',
		position: 'fixed',
		justifyContent: { xs: 'end', md: 'space-between' },
		alignItems: 'center',
		backgroundColor: 'background.paper',
		boxShadow: {
			xs: '0px -1px 2px rgba(0, 0, 0, 0.1)',
			sm: '0px -1px 2px rgba(0, 0, 0, 0.1)',
			md: 'none',
		},
		borderRadius: 0,
		top: { xs: 'auto', md: 0 },
		left: 0,
		right: 0,
		zIndex: PDP_STICKY_COMPONENT_Z_INDEX,
		transition: 'transform 0.15s ease-in-out, opacity 0.15s ease-in-out',
		bottom: { xs: '60px', md: 'auto' },
		padding: { xs: '10px', md: '20px 10px' },
	},
	availabilitySection: {
		display: 'flex',
		width: { xs: 'auto', md: '100%' },
		marginLeft: { xs: '0', md: '25px' },
		marginBottom: { xs: '10px', md: '5px' },
		alignItems: 'center',
	},
	availabilityLabel: {
		marginLeft: '5px',
	},
	leftContainer: {
		display: { xs: 'block', md: 'flex' },
		flexGrow: { xs: 1, md: 0 },
		alignItems: 'center',
	},
	rightContainer: {
		display: { xs: 'block', md: 'flex' },
		flexDirection: 'column',
		flexGrow: { xs: 1, md: 0 },
		alignItems: 'center',
	},
	productPrice: {
		marginBottom: { xs: '10px', md: 0 },
	},
	productImage: {
		width: '80px',
		height: '80px',
		marginRight: '20px',
		borderRadius: '3px',
	},
};
